import { routeConfig } from "./route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

const LazyLoadBZA = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

const LazyLoadMSN = (path: string) => {
  const Comp = lazy(() => import("@LeadGen/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

const LazyLoadCrossBorder = (path: string) => {
  const Comp = lazy(() => import("@CrossBorder/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

const LazyLoadErrorPage = (path: string) => {
  const Comp = lazy(() => import("@/features/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const BaseRouter: routeConfig[] = [
  {
    path: "/Registration",
    element: LazyLoadBZA("Account/Registration"),
    name: "Registration",
    key: "contactListKey",
    isHidden: false
  },
  {
    path: "/signUp_or_login",
    element: LazyLoadBZA("Account/Registration/signUpForTheLoginSelection"),
    name: "Registration",
    key: "signup_loginKey",
    isHidden: true
  },
  {
    path: "/login_signUp",
    element: LazyLoadBZA("Account/Registration/loginForTheSignUpSelection"),
    name: "Registration",
    key: "login_signupKey",
    isHidden: true
  },
  {
    path: "/giveCIDAndUID",
    element: LazyLoadBZA("Account/Registration/giveCIDAndUID"),
    name: "giveCIDAndUID",
    key: "giveCIDAndUIDKey",
    isHidden: true
  },
  {
    path: "/invitation",
    element: LazyLoadBZA("Account/Registration/invitation"),
    name: "invitation",
    key: "InvitationKey",
    isHidden: true
  },
  {
    path: "/customer",
    element: LazyLoadBZA("Account/Customer/selection"),
    name: "customer",
    isHidden: true
  },
  {
    path: "*",
    element: LazyLoadErrorPage("ErrorPage/Notfound"),
    name: "error",
    isHidden: true
  },
  {
    path: "/401",
    element: LazyLoadErrorPage("ErrorPage/401"),
    name: "error",
    isHidden: true
  },
  {
    path: "/403",
    element: LazyLoadErrorPage("ErrorPage/403"),
    name: "403",
    isHidden: true
  },
  {
    path: "/redirect",
    element: LazyLoadErrorPage("empty"),
    name: "",
    isHidden: true
  },
  {
    path: "/errorPage",
    element: LazyLoadErrorPage("ErrorPage/lockAccount"),
    name: "lockAccount",
    isHidden: true
  },
  {
    path: "/chooseMarket",
    element: LazyLoadErrorPage("CrossBorder/ChooseMarket/ChooseMarket"),
    name: "chooseMarket",
    key: "chooseMarketKey",
    isHidden: true
  },
  {
    path: "/mapauthorization",
    element: LazyLoadErrorPage("CrossBorder/MAPAuthorization"),
    name: "MAPAuthorization",
    key: "MAPAuthorizationKey",
    isHidden: true
  },
  {
    path: "/notaccount",
    element: LazyLoadErrorPage("CrossBorder/NotAccount"),
    name: "notaccount",
    key: "notaccountKey",
    isHidden: true
  },
  {
    path: "/importAccount",
    element: LazyLoadErrorPage("CrossBorder/importAccount"),
    name: "importAccount",
    key: "importAccount",
    isHidden: true
  },
  {
    path: "/accountException",
    element: LazyLoadErrorPage("CrossBorder/accountException"),
    name: "accountException",
    key: "accountException",
    isHidden: true
  }
];

export const useUniversalRouters = () => {
  const { t } = useTranslation();
  return [
    {
      path: "/AccountsManagement",
      element: LazyLoadBZA("Account/Settings"),
      name: t("routes.accountSettings"),
      key: "contactListKey",
      icon: "ContactList",
    },
    {
      path: "/createAccount",
      element: LazyLoadBZA("Account/createAccount"),
      name: t("routes.createAccount"),
      key: "accountKey",
      icon: "Repair",
      isHidden: true
    },
  ];
};

export const UniversalRouters: routeConfig[] = [
  {
    path: "/AccountsManagement",
    element: LazyLoadBZA("Account/Settings"),
    name: "账号设置",
    key: "contactListKey",
    icon: "ContactList",
  },
  {
    path: "/createAccount",
    element: LazyLoadBZA("Account/createAccount"),
    name: "创建账号",
    key: "accountKey",
    icon: "Repair",
    isHidden: true
  },
];

export const useMSNUniversalRouters = () => {
  const { t } = useTranslation();
  return [
    {
      path: "/leadgen_accountManagement",
      element: LazyLoadMSN("AccountManagement/index"),
      name: t("routes.accountSettings"),
      key: "accountManagement",
      icon: "ContactList",
    },
    {
      path: "/leadgen_createAccount",
      element: LazyLoadMSN("InitRegistration/Account/createAccount"),
      name: t("routes.createAccount"),
      key: "accountKey",
      icon: "Repair",
      isHidden: true
    },
  ];
};

export const msnUniversalRouters: routeConfig[] = [
  {
    path: "/leadgen_accountManagement",
    element: LazyLoadMSN("AccountManagement/index"),
    name: "账号设置",
    key: "accountManagement",
    icon: "ContactList",
  },
  {
    path: "/leadgen_createAccount",
    element: LazyLoadMSN("InitRegistration/Account/createAccount"),
    name: "创建账号",
    key: "accountKey",
    icon: "Repair",
    isHidden: true
  },
];

export const useCrossBorderUniversalRouters = () => {
  const { t } = useTranslation();
  return [
    {
      path: "/accountManagement",
      element: LazyLoadCrossBorder("Setting/AccountManagement"),
      name: t("routes.accountSettings"),
      key: "accountManagement",
      icon: "ContactList",
    }
  ];
};

export const CrossBorderUniversalRouters: routeConfig[] = [
  {
    path: "/accountManagement",
    element: LazyLoadCrossBorder("Setting/AccountManagement"),
    name: "账号设置",
    key: "accountManagement",
    icon: "ContactList",
  }
];
